export enum MultiFactorChallengeOptions {
  EMAIL = 'Email',
  PHONE = 'Call',
  SMS = 'SMS'
}
